import Layout from "../components/Layout";

export default function Web() {
  return (
    <Layout>
      {/* Hero */}
      <section className="hero-overlay">
        <div className="hero-visuals">
          <img src="/assets/images/webBackground.png" alt="Web Main" />
        </div>
        <div className="hero-content">
          <h1>Web Development</h1>
          <p>
            Elevate your online presence with bespoke, high-performance websites that reflect your brand and drive results.
          </p>
        </div>
      </section>

      {/* Intro */}
      <section className="intro-section">
        <h2>Your customers demand authenticity.</h2>
        <p>
          Struggling to connect with your audience? Our mission is clear: align your website with your unique identity. We blend cutting-edge technology and creative design to help you forge lasting connections and convert visitors into loyal customers.
        </p>
      </section>

      <section className="services">
        <h2>Our Web Development Expertise</h2>
        <div className="services-grid">
          <div className="card">
            <h3>Custom Websites</h3>
            <p>Bespoke designs crafted to fit your brand perfectly.</p>
          </div>
          <div className="card">
            <h3>E-Commerce</h3>
            <p>Powerful online stores with smooth checkout experiences.</p>
          </div>
          <div className="card">
            <h3>SEO Optimization</h3>
            <p>Make sure your site gets seen by the right people.</p>
          </div>
          <div className="card">
            <h3>Ongoing Support</h3>
            <p>Continuous improvements and reliable maintenance.</p>
          </div>
        </div>
      </section>


      {/* Visual Identity */}
      <section className="split-section">
        <div className="split-text">
          <h2>Elevate Your Brand's Visual Identity</h2>
          <p>
            From refined graphics to captivating photography, we create visually stunning websites that tell your story. Our design support empowers your business to stand out in the crowded digital landscape.
          </p>
        </div>
        <div className="split-image">
          <img src="/assets/images/visIdentity.png" alt="Vis Identity" />
        </div>
      </section>

      {/* SEO */}
      <section className="split-section reverse">
        <div className="split-text">
          <h2>Optimise Your Website for Success</h2>
          <p>
            We ensure your site is optimised for search engines, fast-loading, and responsive across all devices-so your customers always get a seamless experience.
          </p>
        </div>
        <div className="split-image">
          <img src="/assets/images/optimisedSuccess.png" alt="Optimised Success" />
        </div>
      </section>

      {/* Hosting */}
      <section className="split-section">
        <div className="split-text">
          <h2>Reliable Hosting Solutions</h2>
          <p>
            Subpar hosting costs you business. Our fast, secure hosting guarantees 99.9% uptime and optimal performance-so your website is always ready to impress.
          </p>
          <a href="/hosting" className="cta-link">
            Discover Our Hosting Solutions
          </a>
        </div>
        <div className="split-image">
          <img src="/assets/images/reliableHosting.png" alt="Reliable Hosting" />
        </div>
      </section>

      {/* Call to Action */}
      <section className="contact-cta">
        <h2>Ready to take your web presence to the next level?</h2>
        <a href="/contact" className="contactLink">
          Contact Us Today
        </a>
      </section>
    </Layout>
  );
}
